<template>
  <footer class="container">
    <p v-scroll-reveal="{ viewOffset: { top: 0 } }">
      Say hello
      <br /><br />
      +46(0)8 22 85 50<br />
      <a href="mailto:info@madepeople.se">info@madepeople.se</a>
    </p>
    <!--
    <p v-scroll-reveal="{ delay: 100, viewOffset: {top: 0} }">
      Sales / Partnerships
      <br><br>
      Sebastian Tornakull<br>
      <a href="mailto:sebastian@madepeople.se">sebastian@madepeople.se</a>
    </p>
    -->
    <p v-scroll-reveal="{ delay: 200, viewOffset: { top: 0 } }">
      Work / Internships
      <br /><br />
      <a href="mailto:anders@madepeople.se">work@madepeople.se</a>
    </p>
    <p v-scroll-reveal="{ delay: 300, viewOffset: { top: 0 } }">
      Made People
      <br /><br />
      Frejgatan 18<br />
      113 49 Stockholm
    </p>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/typography.scss";
footer {
  position: relative;
  display: flex;
  padding-bottom: 4vh !important;
  //margin-bottom:4vh;
  //background:$black;
  color: white;
  p {
    opacity: 1;
    width: 25%;
    padding-right: 3vw;
  }
}
@media (max-width: $tablet) {
  footer {
    flex-wrap: wrap;
    p {
      width: 50%;
      margin-bottom: 100px;
    }
  }
}
@media (max-width: $mobile) {
  footer {
    //display:block;
    padding-left: 0 !important;
    padding-right: 0 !important;
    p {
      border-top: 1px solid rgba(white, 0.1);
      padding: 30px 30px 0 30px;
      margin-bottom: 30px;
      margin-top: 0;
      width: 100%;
      box-sizing: border-box;
      //text-align: center;
    }
  }
}
</style>
